<div class="chart-shell" [class.chart-shell--circular]="type === 'pie' || type === 'doughnut'">
	<!-- Select all / Select none quick actions are hidden for now - click any
	     legend item itself to show or hide that series. -->
	<!-- <div class="chart-legend-actions" *ngIf="hasSelectableLegend()" role="group" aria-label="Chart legend visibility">
		<button type="button" [class.active]="allLegendItemsVisible()" (click)="setLegendItemsVisible(true)">Select all</button>
		<button type="button" [class.active]="noLegendItemsVisible()" (click)="setLegendItemsVisible(false)">Select none</button>
	</div> -->
	<canvas #canvas></canvas>
</div>
